module.exports = __webpack_public_path__ + "1cd1bd78ae200257c3036b66a6668ea3.pdf";